/**
 * The webshop — the third branch of Småken. Unlike catering (a request that
 * gets confirmed) these are things anyone can buy outright and have shipped
 * or picked up.
 *
 * Not open at launch: the list stays empty until real partner products are in,
 * and the shop page shows a "snart" state meanwhile.
 */

export type ShopCategory = 'Dryck' | 'Bakverk' | 'Skafferi' | 'Presentlådor';

export const SHOP_CATEGORIES: ShopCategory[] = ['Dryck', 'Bakverk', 'Skafferi', 'Presentlådor'];

export interface ShopProduct {
  id: string;
  name: string;
  category: ShopCategory;
  /** Who made it. Links to the place profile when `placeSlug` is set. */
  producer: string;
  placeSlug?: string;
  city: string;
  /** One line in the Småken voice — a tip, not a spec sheet. */
  tip: string;
  description: string;
  /** Price in SEK, incl. VAT. Consumers buy at this price. */
  price: number;
  unit: string;
  image: string;
  /** Shippable across Sweden, or pickup / local delivery only. */
  shipping: 'frakt' | 'endast-upphamtning';
  inStock: boolean;
  /** Editorial mark on the card. */
  stamp?: string;
}

export const SHOP_PRODUCTS: ShopProduct[] = [];

export const shopByPlace = (slug: string): ShopProduct[] =>
  SHOP_PRODUCTS.filter((p) => p.placeSlug === slug);
